import RestService from "./rest.service";

class planningService {
  planning(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getplanning(`app/planning/${data}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  mainPlanning() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getmainPlanning(`app/planning`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getAdd(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getplanning(`app/planning/add/${data}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  postAdd(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/planning/save`,data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  
  postCarryScore(serial, teaching, research) {
    return new Promise((fnResolve, fnReject) => {
      let data = {
        serial: serial,
        teaching: teaching,
        research: research
      };
      RestService.carryScore("app/planning/accumulate/get", data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  masterWorkload(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getplanning(`app/planning/portfolio/${data}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  send(serial,remark) {
    return new Promise((fnResolve, fnReject) => {
      let data = {
        rb_pa_evaluate_id: serial,
        remark: ""
      };
      RestService.sendApprove("app/workflow/rubric/request", data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new planningService();
